import { studyReducer, initialStudyState, StudyState, StudyAction } from "@/reducers/study";

import {
  submissionReducer,
  initialSubmissionState,
  SubmissionState,
  SubmissionAction,
} from "@/reducers/submission";

// App State -------------------------------------------------------------------

export interface AppState {
  study: StudyState;
  submission: SubmissionState;
}

export const initialState: AppState = {
  study: initialStudyState,
  submission: initialSubmissionState,
};

// Action Types ----------------------------------------------------------------

export type AppAction = StudyAction | SubmissionAction;

export type Dispatch = React.Dispatch<AppAction>;

// Reducer ---------------------------------------------------------------------

export function appReducer(state: AppState, action: AppAction): AppState {
  const next: AppState = {
    study: studyReducer(state.study, action as StudyAction),
    submission: submissionReducer(state.submission, action as SubmissionAction),
  };

  return next;
}

export { type StudyState, type StudyAction } from "@/reducers/study";
export { type SubmissionState, type SubmissionAction } from "@/reducers/submission";
